import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import Pagination from "react-js-pagination";
import Modal from "./DeleteConfirmModalPopup";

const Investigations = () => {
  const [investigations, setInvestigations] = useState([]);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);
  const [selectedInvestigationId, setSelectedInvestigationId] = useState(false);
  const [search_keywords, setSearchKeyWords] = useState("");
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 10;

  const getAllDepartments = () => {
    const req = scAxiosAdmin.request("/investigations?show_hidden=1", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req
      .then((res) => setInvestigations(res.data))
      .catch((err) => console.log("Error fetching investigations:", err));
  };

  useEffect(() => {
    getAllDepartments();
  }, []);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleSearchChange = (e) => {
    setSearchKeyWords(e.target.value);
    setActivePage(1); // Reset to first page on new search
  };
  const modalDeleteConfirmOpen = (id) => {
    setModalDeleteConfirm(true);
    setSelectedInvestigationId(id);
  };
  const modalDeleteDepartment = (id) => {
    setModalDeleteConfirm(false);

    try {
      const req = scAxiosAdmin.delete(`/investigations/${id}`, {
        method: "delete",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      });
      req
        .then((res) => {
          if (res.status === true) {
            toast.success(res.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(function () {
              window.location.reload();
            }, 3000);
          } else {
            toast.error(res.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
          setInvestigations(res.data);
        })
        .catch((err) => {
          toast.error("Something went wrong! Try again later", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.log("Error fetching investigations:", err);
        });
    } catch (error) {
      toast.error("Something went wrong! Try again later", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      console.log("your log output", error);
    }
  };
  const togglePackageStatus = async (item) => {
    const newStatus = item.status === "1" ? "0" : "1";
    const data = {
      status: newStatus,
    };

    try {
      const response = await scAxiosAdmin.put(
        `/investigations/${item.id}`,
        data
      );
      if (response.status === 200) {
        toast.success("Status updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setInvestigations((prev) =>
          prev.map((pkg) =>
            pkg.id === item.id ? { ...pkg, status: newStatus } : pkg
          )
        );
      } else {
        toast.error("Failed to update status", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  // Filtered and Paginated Data
  const filteredInvestigations = investigations.filter(
    (investigation) =>
      investigation.Product_Name.toLowerCase().includes(
        search_keywords.toLowerCase()
      ) ||
      investigation.Product_Group.toLowerCase().includes(
        search_keywords.toLowerCase()
      )
  );

  const paginatedInvestigations = filteredInvestigations.slice(
    (activePage - 1) * itemsPerPage,
    activePage * itemsPerPage
  );

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card m-b-20">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-7">
                            <h4 className="mt-0 header-title">
                              Investigations
                            </h4>
                          </div>
                          <div className="col-sm-3 text-right">
                            <input
                              type="text"
                              className="form-control"
                              name="search_keywords"
                              id="search_keywords"
                              value={search_keywords}
                              onChange={handleSearchChange}
                              placeholder="Search"
                            />
                          </div>
                          <div className="col-sm-2 text-right">
                            <a
                              href="/add-investigations"
                              className="btn btn-sm btn-primary waves-effect waves-light"
                            >
                              Add investigation
                            </a>
                          </div>
                        </div>
                        <div className="table-rep-plugin">
                          <div
                            className="table-responsive b-0"
                            data-pattern="priority-columns"
                          >
                            <table
                              id="tech-companies-1"
                              className="table table-striped"
                            >
                              <thead>
                                <tr>
                                  <th>Investigation ID</th>
                                  <th>Investigation Name</th>
                                  <th>Investigation Group</th>
                                  <th>OPD Price</th>
                                  <th>IPD Price</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paginatedInvestigations.length > 0 ? (
                                  paginatedInvestigations.map(
                                    (investigation) => (
                                      <tr key={investigation.id}>
                                        <td>#{investigation.id}</td>
                                        <td>{investigation.Product_Name}</td>
                                        <td>{investigation.Product_Group}</td>
                                        <td>{investigation.opd_amount}</td>
                                        <td>{investigation.ipd_price}</td>
                                        <td>
                                          <a
                                            href={`/edit-investigation/${investigation.id}`}
                                          >
                                            <i className="fa fa-pencil-square"></i>
                                          </a>
                                          <a
                                            className="ms-2"
                                            title="Status"
                                            onClick={() =>
                                              togglePackageStatus(investigation)
                                            }
                                          >
                                            {investigation.status === "1" ? (
                                              <i class="fa-solid fa-eye"></i>
                                            ) : (
                                              <i class="fa-solid fa-eye-slash"></i>
                                            )}
                                          </a>
                                          <a
                                            href={`/pages/investigation`}
                                            // href={`/investigation/${investigation.id}`}
                                            target="_blank"
                                          >
                                            <i class="fa-solid fa-laptop"></i>
                                          </a>
                                          <button
                                            className="border-0 bg-transparent p-0"
                                            onClick={() =>
                                              setModalDeleteConfirm(true)
                                            }
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                          <Modal
                                            show={modalDeleteConfirm}
                                            handleClose={() =>
                                              setModalDeleteConfirm(false)
                                            }
                                          >
                                            <div className="custom_reviews_popup">
                                              <h2 className="text-center">
                                                Are you sure you wish to delete
                                                this investigation?
                                              </h2>
                                              <form
                                                className="pop-form"
                                                id="edit_education"
                                              >
                                                <div className="form-group row">
                                                  <div className="col-sm-3 text-center"></div>
                                                  <div className="col-sm-6 text-center">
                                                    <button
                                                      type="button"
                                                      className="blue_btn_box add_staff_btn mt-5 mr-2"
                                                      onClick={() =>
                                                        setModalDeleteConfirm(
                                                          false
                                                        )
                                                      }
                                                    >
                                                      {" "}
                                                      No
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="blue_btn_box add_staff_btn mt-5"
                                                      onClick={() =>
                                                        modalDeleteDepartment(
                                                          investigation.id
                                                        )
                                                      }
                                                    >
                                                      Yes
                                                    </button>
                                                  </div>
                                                  <div className="col-sm-3 text-center"></div>
                                                </div>
                                              </form>
                                            </div>
                                          </Modal>
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="6"
                                      style={{ textAlign: "center" }}
                                    >
                                      No matching departments found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsPerPage}
                          totalItemsCount={filteredInvestigations.length}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          //   itemClass="page-item"
                          //   linkClass="page-link"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Investigations;



// WEBPACK FOOTER //
// ./src/component/admin/Investigations.js